<template>
  <div class="b-account-deletion-form__wrapper">
    <form
      @submit="formSubmit"
      method="POST"
      class="b-form"
    >
      <div class="b-form__group">
        <label for="email"
        >Enter here the email you used to sign up:</label
        >
        <input
          type="email"
          name="email"
          id="email"
          placeholder="Your email"
          v-model.trim="$v.email.$model"
          class="b-form__control"
          :class="{error: $v.email.$error}"
        />
        <div class="b-form__control-error text-danger" v-if="!$v.email.required">
          Email is required
        </div>
      </div>
      <button
        class="b-button b-button--primary"
        type="submit"
      >
        Delete my account
      </button>
    </form>
    <div class="alert alert-danger" v-if="submitStatus === $options.VALIDATION_ERROR">
      Please update the missing fields before submitting your request.
    </div>
    <div class="alert alert-danger" v-if="submitStatus === $options.USER_NOT_FOUND">
      There's <b>0</b> users with this email in our <b>customer base</b>.
      Please contact <a href="mailto:support@adtranquility.com">support@adtranquility.com</a>
      to help you locate your subscription.
    </div>
    <div class="alert alert-success" v-if="submitStatus === $options.SUCCESS">
      We've sent you an email with a link to complete the deletion process.
      For any questions, please contact
      <a href="mailto:support@adtranquility.com">support@adtranquility.com</a>
    </div>
    <div class="alert alert-warning small" v-if="submitStatus === $options.NO_GPS_SUBSCRIPTION">
      <h5>Unable to delete your account?</h5>
      <p>
      <strong>
        The option to delete your AdTranquility account through this page is exclusively applicable
        to customers who purchased our product via Google Play Store and/or App Store.</strong>
      </p>

      <strong>If you're receiving this message:</strong>
      <ol>
        <li>
          <strong>The email address you provided is incorrect.</strong><br>
          Please recheck your spelling or provide the correct email address. This will
          allow our system to accurately locate your Google Play Store and/or
          App Store subscription.
          <br><br>
          <em>If</em> your spelling is correct:
        </li>
        <li>
          <strong>You have not subscribed to AdTranquility through Google Play Store nor
            through App Store.</strong><br>
          Please refer to our
          <a href="https://adtranquility.zendesk.com/hc/en-us/articles/360014282400">Cancellation
          and Refund Policy</a> for a step-by-step guide on how to Cancel/Refund your
          subscription and request Account deletion.
        </li>
      </ol>

      Should you require step-by-step guidance on next steps, do not hesitate to
      contact us directly at
      <a href="mailto:support@adtranquility.com">support@adtranquility.com</a>.
    </div>
    <div class="alert alert-primary" v-if="submitStatus === $options.PENDING">
      Please wait, sending.
    </div>
    <div class="alert alert-danger" v-if="submitStatus === $options.ERROR">
      Form error. Try to reload the page and submit again.
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  required,
  email,
} from 'vuelidate/lib/validators';

export default {
  name: 'AccountDeletionForm',
  ERROR: 'error',
  VALIDATION_ERROR: 'validation_error',
  OK: 'ok',
  PENDING: 'pending',
  MISSPELLED: 'misspelled',
  NOTFOUND: 'not_found',
  PREVIOUSLY_CANCELED: 'previously_canceled',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  NO_GPS_SUBSCRIPTION: 'NO_GPS_SUBSCRIPTION',
  SUCCESS: 'SUCCESS',
  data() {
    return {
      email: '',
      submitStatus: null,
      submitAttempts: 0,
      customerFound: false,
      latestCanceledSubscriptionDate: null,
    };
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();
      if ((this.submitStatus === this.$options.PENDING) || this.submitAttempts >= 3) return;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = this.$options.VALIDATION_ERROR;
      } else {
        this.submitStatus = this.$options.PENDING;
        axios.post(process.env.VUE_APP_ADT_API_DELETION_ENDPOINT, {
          email: this.email,
        })
          .then((response) => {
            this.submitAttempts += 1;
            this.submitStatus = response.data.data.result;

            if (this.submitStatus === this.$options.SUCCESS) {
              this.$v.$reset();
              this.email = '';
            }
          })
          .catch(() => {
            this.submitStatus = this.$options.ERROR;
          });
      }
    },
  },
  validations: {
    email: {
      email,
      required,
    },
  },
};
</script>
